import { PersonFill } from "react-bootstrap-icons";
import { AmexIcon, BankIcon, CardGeneralIcon, KlarnaIcon } from "./CardNetworkIcon";
import { cn } from "@utils";

const PersonIcon = ({ className }) => (
  <PersonFill
    size={20}
    className={cn("text-white", className ? className : "")}
  />
);

const iconMap = {
  Bank: BankIcon,
  Card: CardGeneralIcon,
  Amex: AmexIcon,
  Klarna: KlarnaIcon,
  Default: PersonIcon,
};

const bgMap = {
  Bank: "#71717A",
  Card: "#27272A",
  Amex: "#016FD0",
  Klarna: "#FEB4C7",
  Default: "#27272A",
};

const profilePaymentTypes = [
  { key: "allowOpenBanking", type: "Bank" },
  { key: "allowCards", type: "Card" },
  { key: "allowAmex", type: "Amex" },
];

export const ProfilePaymentIcons = ({ profile, size = "md" }) => {
  const active = profilePaymentTypes.filter((p) => profile?.[p.key]);

  if (active.length === 0) return null;

  const overlap = { sm: "-space-x-1", md: "-space-x-2", lg: "-space-x-3" };

  return (
    <div className={`inline-flex items-center ${overlap[size] ?? overlap.md}`}>
      {active.map((p) => (
        <ProfilePaymentIcon key={p.type} paymentType={p.type} size={size} />
      ))}
    </div>
  );
};

const sizes = {
  sm: { container: "w-5 h-5", icon: "scale-[0.6]" },
  md: { container: "w-10 h-10", icon: "scale-100" },
  lg: { container: "w-14 h-14", icon: "scale-[1.4]" },
};

export const ProfilePaymentIcon = ({ paymentType, size = "md" }) => {
  const Icon = iconMap[paymentType];
  const bg = bgMap[paymentType] ?? "#71717A";
  const s = sizes[size] ?? sizes.md;

  return (
    <div
      className={`flex items-center justify-center rounded-full shrink-0 ${s.container}`}
      style={{ backgroundColor: bg }}
    >
      {Icon ? <Icon className={s.icon} /> : null}
    </div>
  );
};
